namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoHd3Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoHd3';
    }
}
